<div class="contact-activity" [style.height]="panelHeight">
  <div class="custom-mat-spinner" *ngIf="isSpinnerShown">
    <mat-spinner></mat-spinner>
    <div class="text">Data loading...</div>
  </div>

  <!-- Segmented switcher -->
  <div class="seg">
    <button type="button" class="seg-btn" [class.active]="view === 'activity'" (click)="setView('activity')">
      Activity<span class="c">{{ eventCount }}</span>
    </button>
    <button type="button" class="seg-btn" [class.active]="view === 'notes'" (click)="setView('notes')">
      Notes<span class="c">{{ notes.length }}</span>
    </button>
  </div>

  <!-- ============================== ACTIVITY ============================== -->
  <div class="ca-scroll" *ngIf="view === 'activity'">
    <ng-container *ngIf="dayGroups.length > 0; else noActivity">
      <div *ngFor="let g of dayGroups; trackBy: trackByGroup">
        <div class="tl-day">{{ g.label }}</div>
        <div class="tl">
          <div class="tl-item" *ngFor="let it of g.items; trackBy: trackByItem">
            <div class="tl-rail">
              <div class="tl-icon" [ngClass]="'tone-' + it.tone">
                <svg viewBox="0 0 20 20" width="16" height="16"
                  [attr.fill]="(it.icon === 'sparkle' || it.icon === 'dot') ? 'currentColor' : 'none'"
                  [attr.stroke]="(it.icon === 'sparkle' || it.icon === 'dot') ? 'none' : 'currentColor'"
                  stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" [ngSwitch]="it.icon">
                  <path *ngSwitchCase="'cloud'"
                    d="M6.5 15h8a3 3 0 0 0 .4-6A4.3 4.3 0 0 0 6.6 7.6 3.4 3.4 0 0 0 6.5 15zM10 13V7m0 0L8 9m2-2l2 2" />
                  <path *ngSwitchCase="'sparkle'" d="M10 2.5l1.5 4L15.5 8l-4 1.5L10 13.5 8.5 9.5 4.5 8l4-1.5L10 2.5z" />
                  <g *ngSwitchCase="'tag'" fill="none">
                    <path d="M9.5 3.5H5a1.5 1.5 0 0 0-1.5 1.5v4.5l7.5 7.5 6-6-7.5-7.5z" />
                    <circle cx="7" cy="7" r="1.1" />
                  </g>
                  <path *ngSwitchCase="'edit'" d="M13 4l3 3-9 9H4v-3l9-9z" />
                  <path *ngSwitchCase="'check'" d="M4 10.5l4 4 8-9" />
                  <g *ngSwitchCase="'xero'">
                    <path d="M16 5.5A6 6 0 1 0 17 9" />
                    <path d="M17 4.5v3h-3" />
                  </g>
                  <path *ngSwitchCase="'card'" d="M3 7h14M3 7v8h14V7M3 7l1.6-3h10.8L17 7M7.5 12h3" />
                  <circle *ngSwitchDefault cx="10" cy="10" r="3" />
                </svg>
              </div>
              <div class="tl-line"></div>
            </div>
            <div class="tl-body">
              <!-- The day is in the heading above, so the row carries only the time; the full
                   date and time, in the viewer's timezone, are on hover. -->
              <div class="tl-head">
                <span class="tl-title">{{ it.title }}</span>
                <time class="tl-when" [attr.datetime]="it.ts.toISOString()" [title]="fullStamp(it.ts)">{{ clock(it.ts) }}</time>
              </div>
              <div class="tl-detail" *ngIf="it.detail">{{ it.detail }}</div>
              <div class="tl-actor" *ngIf="it.actor && it.actor !== 'System'">
                <span class="pav s18" [ngClass]="avatarClass(it.actor)">{{ initials(it.actor) }}</span>
                {{ it.actor }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noActivity>
      <div class="ca-empty">No activity yet.</div>
    </ng-template>
  </div>

  <!-- =============================== NOTES =============================== -->
  <ng-container *ngIf="view === 'notes'">
    <!-- Category filter bar -->
    <div class="nt-filterbar" *ngIf="presentTypes.length > 1">
      <span class="nt-filterbar-count">
        {{ shownNotes.length }} {{ shownNotes.length === 1 ? 'note' : 'notes' }}
        <ng-container *ngIf="activeType"> in <b>{{ activeType.label }}</b></ng-container>
      </span>
      <div class="nt-filtermenu-wrap" #filterWrap>
        <button type="button" class="nt-filterbtn" [class.active]="activeType" (click)="toggleFilter()">
          <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M3.5 5.5h13M6 10h8M8.5 14.5h3" />
          </svg>
          {{ activeType ? activeType.label : 'All types' }}
          <span class="chev">
            <svg viewBox="0 0 20 20" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.7"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 7.5l5 5 5-5" />
            </svg>
          </span>
        </button>
        <div class="nt-filterpop" *ngIf="filterOpen">
          <div class="cmp-typelabel">Filter by type</div>
          <div class="nt-filteritem" (click)="setTypeFilter('all')">
            <span class="d muted"></span>
            All types
            <span class="ct">{{ notes.length }}</span>
            <span class="ck" *ngIf="typeFilter === 'all'">
              <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 10.5l4 4 8-9" />
              </svg>
            </span>
          </div>
          <div class="nt-filteritem" *ngFor="let t of presentTypes" (click)="setTypeFilter(t.id)">
            <span class="d" [style.background]="toneColor[t.tone]"></span>
            {{ t.label }}
            <span class="ct">{{ countFor(t.id) }}</span>
            <span class="ck" *ngIf="typeFilter === t.id">
              <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 10.5l4 4 8-9" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>


    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%;">
      <!-- Thread -->
      <div class="ca-scroll">
        <div class="ca-empty" *ngIf="shownNotes.length === 0">
          {{ typeFilter === 'all' ? 'No notes yet. Start the conversation below.' : 'No notes of this type yet.' }}
        </div>
        <div class="nt" *ngIf="shownNotes.length > 0">
          <div class="nt-item" *ngFor="let n of shownNotes; trackBy: trackByNote" [class.me]="n.mine">
            <div class="pav" [ngClass]="avatarClass(n.author)">{{ initials(n.author) }}</div>
            <div class="nt-main">
              <div class="nt-head">
                <span class="nt-name">{{ n.author }}</span>
                <span class="nt-you" *ngIf="n.mine">You</span>
                <span class="nt-time">{{ stamp(n.ts) }}</span>
              </div>
              <div class="nt-typerow" *ngIf="n.category && n.category !== 'general'">
                <span class="nt-type" [ngClass]="'tone-' + typeTone(n.category)">
                  <span class="d"></span>{{ typeLabel(n.category) }}
                </span>
              </div>

              <!-- Rewriting the note in place; the bubble is the read state. -->
              <div class="nt-edit" *ngIf="editingId === n.id; else noteBubble">
                <textarea rows="2" #editTa [value]="editText" (input)="editText = editTa.value"
                  (keydown.escape)="cancelEdit()"></textarea>
                <div class="nt-edit-actions">
                  <button type="button" class="nt-btn nt-btn--primary" [disabled]="isSavingEdit || !editText.trim()"
                    (click)="saveEdit(n)">Save</button>
                  <button type="button" class="nt-btn" (click)="cancelEdit()">Cancel</button>
                </div>
              </div>

              <ng-template #noteBubble>
                <div class="nt-bubble">
                  <ng-container *ngFor="let p of n.parts">
                    <span class="mention" *ngIf="p.mention">{{ p.text }}</span><ng-container *ngIf="!p.mention">{{ p.text
                      }}</ng-container>
                  </ng-container>
                </div>

                <!-- Your own notes only, and only once they have been saved. -->
                <div class="nt-actions" *ngIf="canModify(n) && confirmDeleteId !== n.id">
                  <button type="button" class="nt-action" (click)="startEdit(n)">Edit</button>
                  <span class="nt-action-sep">·</span>
                  <button type="button" class="nt-action nt-action--danger" (click)="askDelete(n)">Delete</button>
                </div>

                <div class="nt-confirm" *ngIf="confirmDeleteId === n.id">
                  <span>Delete this note?</span>
                  <button type="button" class="nt-btn nt-btn--danger" (click)="confirmDelete(n)">Delete</button>
                  <button type="button" class="nt-btn" (click)="cancelDelete()">Cancel</button>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- Composer -->
      <div class="cmp-wrap">
        <div class="cmp" #composerRoot>
          <!-- Mention menu -->
          <div class="mm" *ngIf="mentionMenu">
            <div class="mm-label">Mention</div>
            <div class="mm-item" *ngFor="let m of mentionMenu.items; let i = index"
              [class.active]="i === mentionMenu.active" (mouseenter)="mentionMenu.active = i"
              (mousedown)="$event.preventDefault(); pickMention(m)">
              <div class="pav s28" [ngClass]="avatarClass(m.name)">{{ initials(m.name) }}</div>
              <span class="mm-name">{{ m.name }}</span>
              <span class="mm-role">{{ m.emailId }}</span>
            </div>
          </div>

          <!-- Input with live mention highlight -->
          <div class="cmp-input hl">
            <div class="cmp-hl" #highlight aria-hidden="true"><ng-container *ngFor="let p of highlightParts"><span
                  class="mention-live" *ngIf="p.mention">{{ p.text }}</span><ng-container *ngIf="!p.mention">{{ p.text
                  }}</ng-container></ng-container></div>
            <textarea #composerTa rows="1" placeholder="Write a note…  use @ to mention a teammate"
              (input)="onComposerInput($event)" (keydown)="onComposerKeydown($event)"
              (scroll)="syncScroll()"></textarea>
          </div>

          <!-- Notifying row -->
          <div class="cmp-ment" *ngIf="notifying.length > 0">
            <span class="cmp-ment-lbl">
              <svg viewBox="0 0 20 20" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.7"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 8.5a4 4 0 0 1 8 0c0 3.5 1.3 4.5 1.3 4.5H4.7S6 12 6 8.5zM8.4 15.5a1.7 1.7 0 0 0 3.2 0" />
              </svg>
              Notifying
            </span>
            <span class="ment-chip" *ngFor="let m of notifying">
              <div class="pav s24" [ngClass]="avatarClass(m.name)">{{ initials(m.name) }}</div>
              {{ m.name }}
              <span class="x" (click)="dropMention(m.name)">&times;</span>
            </span>
          </div>

          <!-- Footer -->
          <div class="cmp-foot">
            <div class="cmp-type" #typeWrap>
              <button type="button" class="cmp-typebtn" (click)="toggleTypeMenu()">
                <span class="d" [style.background]="toneColor[composerType.tone]"></span>
                {{ composerType.label }}
                <span class="chev">
                  <svg viewBox="0 0 20 20" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.7"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 7.5l5 5 5-5" />
                  </svg>
                </span>
              </button>
              <div class="cmp-typemenu" *ngIf="typeOpen">
                <div class="cmp-typelabel">Note type</div>
                <div class="cmp-typeitem" *ngFor="let t of noteTypes" (click)="selectComposerType(t)">
                  <span class="d" [style.background]="toneColor[t.tone]"></span>
                  {{ t.label }}
                  <span class="ck" *ngIf="t.id === composerType.id">
                    <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 10.5l4 4 8-9" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <button type="button" class="cmp-at" (click)="insertAt()" title="Mention a teammate">
              <span class="glyph">&#64;</span> Mention
            </button>
            <span class="cmp-spacer"></span>
            <span class="cmp-kbd">&#8984;&#8629;</span>
            <button type="button" class="btn-send" [disabled]="!composerText.trim() || isSending" (click)="send()">
              <svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 10l13-5.5L11.5 17 9.5 11 4 10z" />
              </svg>
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>